import LmsFormGenerator, { BCFormController } from "../ui/LmsFormGenerator";
import { useParseRouteActions,useFetchData } from "../../../helpers/GlobalHelper";
import LmsTable from "../ui/LmsTable";
import { LmsEndpoints } from "../../constants/LmsEndpoints";
import { GlobalConstants } from "../../constants/GlobalConstants";

const LmsBankAccountsTable = () => {
  const actionsButtons = ["add", "edit", "remove", "export"];
  return <LmsTable
    actionButtons={actionsButtons}
    apiSuffix="vendors/bank-accounts"
    deleteSuffix="orgs/bank-infos"
  />;
};

export const addBanksAccountFormFields = (myForm, data = null as any, isAdd = false) => {
  myForm.addCenteredGroup([myForm.getDropdownField("Organization", "vendors/list-organizations", { required: true, name: "organizationId" })]);
  myForm.addCenteredGroup([myForm.getDropdownField("Special Purpose Entity", "orgs/list-spes")]);
  myForm.addCenteredGroup([myForm.getDropdownField("Bank", LmsEndpoints.Orgs.GET.LIST_BANK_ORGS, { required: true, name: "bankOrganizationId" })]);
  myForm.addCenteredGroup([myForm.getMaskedInputField("Bank Account Number", data?.bankAccountNumber, { required: isAdd })]);
  myForm.addCenteredGroup([myForm.getInputField("Street On Bank Account", { name: "addressOnBankAccount" })]);
  myForm.addCenteredGroup([myForm.getInputField("Name On Bank Account")]);
  myForm.addCenteredGroup([myForm.getInputField("City On Bank Account")]);
  myForm.addCenteredGroup([myForm.getInputField("State On Bank Account")]);
  myForm.addCenteredGroup([myForm.getInputField("Zip On Bank Account", { fieldType: GlobalConstants.InputTypes.NUMBER, validations: ["zipcode"] })]);
  myForm.addCenteredGroup([myForm.getDropdownField("Bank Routing", "bankaccount/list-bank-routing", { dependencyField: "bankOrganizationId", name: "bankRoutingId" })]);
  myForm.addCenteredGroup([myForm.getInputField("Reference Detail")]);
  myForm.addCenteredGroup([myForm.getCheckboxField("Is Default", { width: 3, inline: true })]);
  myForm.addCenteredGroup([myForm.getCheckboxField("Is Active", { width: 3, inline: true })]);
  return myForm;
};

const AddBankAccountForm = () => {
  const myForm = addBanksAccountFormFields(new BCFormController({ isActive: true }, { submitSuffix: "/bankaccount/bank-account-info" }), true);
  const formActions = ["save-new", "save-close", "close"];
  return (<LmsFormGenerator myForm={myForm} actions={formActions} />);
};

const EditBanksAccountForm = ({ id }) => {
  const [{ data = {}, isLoading, error }] = useFetchData(`/orgs/bank-info/${id}`, { skipCache: true });
  const myForm = addBanksAccountFormFields(new BCFormController(data, { submitSuffix: "/orgs/update-bank-info", deleteSuffix: "orgs/bank-infos" }), data);
  const formActions = ["save", "save-close", "delete", "close"];
  return (<LmsFormGenerator myForm={myForm} isLoading={isLoading} error={error} actions={formActions} />);
};

const LmsVendorsBankAccounts = ({ params = {}, history }) => {
  const allowedActions = ["add"];
  const { isAdd, isEdit, isMainPage, isActionAllowed, id } = useParseRouteActions(params,allowedActions);  
  if (!isActionAllowed) {
    history.goBack();
  }

  return <>
    {isMainPage && <LmsBankAccountsTable />}
    {isAdd && <AddBankAccountForm />}
    {isEdit && <EditBanksAccountForm id={id} />}
  </>;
};

export default LmsVendorsBankAccounts;